import React from 'react'

function SeamlessGiving() {
  return (
    <div>
      <p>PayPal covers all transaction fees. You're donating to PayPal Giving Fund, a 501(c)(3) charity, <span className=' text-blue-700'>subject to its terms.</span>Donations can take <span className='text-blue-700'>up to 45 days</span>to get to your chosen charity. It's rare, but if <span className='text-blue-700'>we can't send your money to this charity,</span> we'll ask you to recommend another. If we can't reach you, we'll send it to a similar charity and keep you updated. Your donation is typically tax-dedcuctible in the US.</p>
      <p>The logos on this site and description under "About this charity" are provided by and managed by the charities themselves.</p>
    </div>
  )
}

export default SeamlessGiving
